/**
 * Util for the Bulk Tank view.
 * Used for calculating the size of each bulk tank.
 */

var VRC = VRC || {};

VRC.BulkViewUtil = (function () {
	var calculateSize = function (marginPercent, numberOfColumns) {
		return (100 - (marginPercent * 2 * numberOfColumns)) / numberOfColumns;
	};

	return {
		calculateSize: calculateSize
	}
})();
